import React from 'react'
// HEADER
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'

const ProfilEquipe = () => {
    return (
        <div className='container-fluid'>

            {/* HEADER */}
            <HeaderReturn title='Profil' link='/homePageEquipe' />

        </div>
    )
}

export default ProfilEquipe